import { render, staticRenderFns } from "./QuestionReferralList.vue?vue&type=template&id=60ff19fc&scoped=true&"
import script from "@/scripts/QA/Question/components/QuestionReferralList?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/QuestionReferralList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff19fc",
  null
  
)

export default component.exports